import React from "react";
import { cn } from "@/lib/utils";

interface ScalableContainerProps {
	children: React.ReactNode;
	baseWidth?: number; // Base design width (default: 1440px) - kept for API compatibility but not used
	className?: string;
}

/**
 * ScalableContainer - Simple centered container that wraps content
 * No scaling applied - allows browser zoom to work properly
 */
export default function ScalableContainer({
	children,
	baseWidth = 1440,
	className,
}: ScalableContainerProps) {
	return (
		<div
			className={cn("flex justify-center w-full", className)}
			style={{
				width: "100%",
			}}
		>
			<div
				className="w-full"
				style={{
					maxWidth: `${baseWidth / 16}rem`,
					width: "100%",
				}}
			>
				{children}
			</div>
		</div>
	);
}
